import { Badge } from 'react-bootstrap';
import ResponsiveTable from '../../../../shared/components/ResponsiveTable';
import { SortedColumn } from '../../../../shared/components/ResponsiveTable/models';
import {
  getBrowserTimezone,
  toPMIFormatDateWithTime,
} from '../../../../shared/helpers';
import { EnrollmentLog } from '../../models';

export interface EnrollmentLogsTableProps {
  logs: EnrollmentLog[];
}

const tableColumns: SortedColumn[] = [
  {
    name: 'dealId',
    title: 'Agreement ID',
    cell: ({ row }) => <span>{row.original?.dealId}</span>,
    width: 10,
    sortingEnabled: false,
  },
  {
    name: 'sku',
    title: 'SKU',
    cell: ({ row }) => <span>{row.original?.sku}</span>,
    width: 5,
    sortingEnabled: false,
  },
  {
    name: 'name',
    title: 'Name',
    cell: ({ row }) => (
      <span data-exclude-lg>
        {row.original?.firstName} {row.original?.lastName}
      </span>
    ),
    width: 15,
    sortingEnabled: false,
  },
  {
    name: 'email',
    title: 'Email',
    cell: ({ row }) => <span data-exclude-lg>{row.original.email}</span>,
    width: 5,
    sortingEnabled: false,
  },
  {
    name: 'orderStatus',
    title: 'Status ',
    cell: ({ row }) => {
      const orderStatus = row.original?.orderStatus;
      const reportStatus =
        row.original?.reportPrimaryStatus ||
        row.original?.reportSecondaryStatus;
      return (
        <div>
          {reportStatus && (
            <Badge bg="info" className="d-block mb-2">
              {reportStatus}
            </Badge>
          )}
          <Badge
            bg={
              orderStatus.toLowerCase() === 'completed' ? 'success' : 'warning'
            }
            className="d-block"
          >
            {orderStatus}
          </Badge>
        </div>
      );
    },
    width: 5,
    sortingEnabled: false,
  },
  {
    name: 'created',
    title: `Date/Time (${getBrowserTimezone()})`,
    cell: (cntx) => (
      <span className={` fw-normal label`} data-testid="data-status">
        {cntx.row.original?.createdDate
          ? toPMIFormatDateWithTime(cntx.row.original?.createdDate)
          : ''}
      </span>
    ),
    width: 15,
    sortingEnabled: false,
  },
];

export default function EnrollmentLogsTable({
  logs,
}: EnrollmentLogsTableProps) {
  return (
    <ResponsiveTable
      data={logs}
      columns={tableColumns}
      showPagination={false}
      onSort={() => {}}
    />
  );
}
